__turbopack_context__.v({
  "btn-clearfix": "FiltersContainer-module-scss-module__7q1xGq__btn-clearfix",
  "btn-container": "FiltersContainer-module-scss-module__7q1xGq__btn-container",
  "container": "FiltersContainer-module-scss-module__7q1xGq__container",
  "filter-title": "FiltersContainer-module-scss-module__7q1xGq__filter-title",
  "filters": "FiltersContainer-module-scss-module__7q1xGq__filters",
  "in-dialog": "FiltersContainer-module-scss-module__7q1xGq__in-dialog",
  "view-results": "FiltersContainer-module-scss-module__7q1xGq__view-results",
});
